import { reduxActions as ATTRIBUTE } from "_constants/attribute.constants";
import { FAILURE, LOADING, SUCCESS } from "_constants/redux.constants";
import initialAttributeState from "../attribute.initialState";

const one = {
  [ATTRIBUTE.ONE_STARTED]: (state) => ({
    ...state,
    one: {
      ...state.one,
      status: LOADING
    }
  }),

  [ATTRIBUTE.ONE_SUCCESS]: (state, { payload }) => ({
    ...state,
    one: {
      ...state.one,
      data: payload?.data?.[0] ?? null,
      status: SUCCESS
    }
  }),

  [ATTRIBUTE.ONE_FAIL]: (state, { payload }) => ({
    ...state,
    one: {
      ...state.one,
      error: payload?.error ?? null,
      status: FAILURE
    }
  }),

  [ATTRIBUTE.ONE_RESET]: (state) => ({
    ...state,
    one: initialAttributeState.one
  })
}

export default one;
